/* eslint-disable react-refresh/only-export-components */

import React, { useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import { useU2000LUStateHandlers } from '../u2000Core/reducer/formReducer/U2000LUHandlers';
import type { U2000LUState } from '../u2000Core/reducer/formReducer/U2000LUState';
import type { U3146InitLU } from './U3146Service';

export type U3146InitLUContext = U2000LUState['personalization'] &
  U3146InitLU & {
    launchSearch: boolean;
    hideSearch: boolean;
    nbRecordPerPage: number;
  };

export interface U3146ContextType {
  luStateHandlers: ReturnType<typeof useU2000LUStateHandlers>;
  initLU: U3146InitLUContext;
}

interface U3146ContextProviderProps {
  initLU: U3146InitLUContext;
  children: ReactNode;
}

const U3146Context = React.createContext<U3146ContextType | undefined>(undefined);

export const U3146ContextProvider: React.FC<U3146ContextProviderProps> = ({ initLU, children }) => {
  const U2000LUStateHandlers = useU2000LUStateHandlers({ initLU: initLU as U3146InitLUContext & U2000LUState });

  const contextValue = useMemo<U3146ContextType>(
    () => ({
      luStateHandlers: U2000LUStateHandlers,
      initLU,
    }),
    [U2000LUStateHandlers, initLU],
  );

  return <U3146Context.Provider value={contextValue}>{children}</U3146Context.Provider>;
};

export function useU3146Context(): U3146ContextType {
  const context = useContext(U3146Context);
  if (!context) {
    throw new Error('useU3146Context must be used within a U3146ContextProvider');
  }
  return context;
}
